module.exports = __webpack_public_path__ + "img/image 20.5ca5b58b.png";